// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file penumbra/view/v1/view.proto (package penumbra.view.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { AddressByIndexRequest, AddressByIndexResponse, AppParametersRequest, AppParametersResponse, AssetMetadataByIdRequest, AssetMetadataByIdResponse, AssetsRequest, AssetsResponse, AuctionsRequest, AuctionsResponse, AuthorizeAndBuildRequest, AuthorizeAndBuildResponse, BalancesRequest, BalancesResponse, BroadcastTransactionRequest, BroadcastTransactionResponse, DelegationsByAddressIndexRequest, DelegationsByAddressIndexResponse, EphemeralAddressRequest, EphemeralAddressResponse, FMDParametersRequest, FMDParametersResponse, GasPricesRequest, GasPricesResponse, IndexByAddressRequest, IndexByAddressResponse, NoteByCommitmentRequest, NoteByCommitmentResponse, NotesForVotingRequest, NotesForVotingResponse, NotesRequest, NotesResponse, NullifierStatusRequest, NullifierStatusResponse, OwnedPositionIdsRequest, OwnedPositionIdsResponse, StatusRequest, StatusResponse, StatusStreamRequest, StatusStreamResponse, SwapByCommitmentRequest, SwapByCommitmentResponse, TransactionInfoByHashRequest, TransactionInfoByHashResponse, TransactionInfoRequest, TransactionInfoResponse, TransactionPlannerRequest, TransactionPlannerResponse, UnbondingTokensByAddressIndexRequest, UnbondingTokensByAddressIndexResponse, UnclaimedSwapsRequest, UnclaimedSwapsResponse, WalletIdRequest, WalletIdResponse, WitnessAndBuildRequest, WitnessAndBuildResponse, WitnessRequest, WitnessResponse } from "./view_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * The view RPC is used by a view client, who wants to do some
 * transaction-related actions, to request data from a view service, which is
 * responsible for synchronizing and scanning the public chain state with one or
 * more full viewing keys.
 *
 * @generated from service penumbra.view.v1.ViewService
 */
export const ViewService = {
    typeName: "penumbra.view.v1.ViewService",
    methods: {
        /**
         * Get current status of chain sync
         *
         * @generated from rpc penumbra.view.v1.ViewService.Status
         */
        status: {
            name: "Status",
            I: StatusRequest,
            O: StatusResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Stream sync status updates until the view service has caught up with the chain.
         * Returns a stream of `StatusStreamResponse`s.
         *
         * @generated from rpc penumbra.view.v1.ViewService.StatusStream
         */
        statusStream: {
            name: "StatusStream",
            I: StatusStreamRequest,
            O: StatusStreamResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Queries for notes that have been accepted by the chain.
         * Returns a stream of `NotesResponse`s.
         *
         * @generated from rpc penumbra.view.v1.ViewService.Notes
         */
        notes: {
            name: "Notes",
            I: NotesRequest,
            O: NotesResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Returns a stream of `NotesForVotingResponse`s.
         *
         * @generated from rpc penumbra.view.v1.ViewService.NotesForVoting
         */
        notesForVoting: {
            name: "NotesForVoting",
            I: NotesForVotingRequest,
            O: NotesForVotingResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Queries for metadata about known assets.
         * Returns a stream of `AssetsResponse`s.
         *
         * @generated from rpc penumbra.view.v1.ViewService.Assets
         */
        assets: {
            name: "Assets",
            I: AssetsRequest,
            O: AssetsResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Query for metadata about a specific asset, by asset ID.
         *
         * This is the same as the method on the shielded pool's `QueryService`, but exposing it
         * here allows a view server to provide more specific or opinionated asset metadata -- like
         * using an asset registry to provide tickers, symbols, etc.
         *
         * @generated from rpc penumbra.view.v1.ViewService.AssetMetadataById
         */
        assetMetadataById: {
            name: "AssetMetadataById",
            I: AssetMetadataByIdRequest,
            O: AssetMetadataByIdResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for the current app parameters.
         *
         * @generated from rpc penumbra.view.v1.ViewService.AppParameters
         */
        appParameters: {
            name: "AppParameters",
            I: AppParametersRequest,
            O: AppParametersResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for the current gas prices.
         *
         * @generated from rpc penumbra.view.v1.ViewService.GasPrices
         */
        gasPrices: {
            name: "GasPrices",
            I: GasPricesRequest,
            O: GasPricesResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for the current FMD parameters.
         *
         * @generated from rpc penumbra.view.v1.ViewService.FMDParameters
         */
        fMDParameters: {
            name: "FMDParameters",
            I: FMDParametersRequest,
            O: FMDParametersResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for an address given an address index
         *
         * @generated from rpc penumbra.view.v1.ViewService.AddressByIndex
         */
        addressByIndex: {
            name: "AddressByIndex",
            I: AddressByIndexRequest,
            O: AddressByIndexResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for wallet id
         *
         * @generated from rpc penumbra.view.v1.ViewService.WalletId
         */
        walletId: {
            name: "WalletId",
            I: WalletIdRequest,
            O: WalletIdResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for an address given an address index
         *
         * @generated from rpc penumbra.view.v1.ViewService.IndexByAddress
         */
        indexByAddress: {
            name: "IndexByAddress",
            I: IndexByAddressRequest,
            O: IndexByAddressResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for an ephemeral address
         *
         * @generated from rpc penumbra.view.v1.ViewService.EphemeralAddress
         */
        ephemeralAddress: {
            name: "EphemeralAddress",
            I: EphemeralAddressRequest,
            O: EphemeralAddressResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for balance of a given address.
         * Returns a stream of `BalancesResponses`.
         *
         * @generated from rpc penumbra.view.v1.ViewService.Balances
         */
        balances: {
            name: "Balances",
            I: BalancesRequest,
            O: BalancesResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Query for a note by its note commitment, optionally waiting until the note is detected.
         *
         * @generated from rpc penumbra.view.v1.ViewService.NoteByCommitment
         */
        noteByCommitment: {
            name: "NoteByCommitment",
            I: NoteByCommitmentRequest,
            O: NoteByCommitmentResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for a swap by its swap commitment, optionally waiting until the swap is detected.
         *
         * @generated from rpc penumbra.view.v1.ViewService.SwapByCommitment
         */
        swapByCommitment: {
            name: "SwapByCommitment",
            I: SwapByCommitmentRequest,
            O: SwapByCommitmentResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for all unclaimed swaps.
         *
         * @generated from rpc penumbra.view.v1.ViewService.UnclaimedSwaps
         */
        unclaimedSwaps: {
            name: "UnclaimedSwaps",
            I: UnclaimedSwapsRequest,
            O: UnclaimedSwapsResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Query for whether a nullifier has been spent, optionally waiting until it is spent.
         *
         * @generated from rpc penumbra.view.v1.ViewService.NullifierStatus
         */
        nullifierStatus: {
            name: "NullifierStatus",
            I: NullifierStatusRequest,
            O: NullifierStatusResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for a given transaction by its hash.
         *
         * @generated from rpc penumbra.view.v1.ViewService.TransactionInfoByHash
         */
        transactionInfoByHash: {
            name: "TransactionInfoByHash",
            I: TransactionInfoByHashRequest,
            O: TransactionInfoByHashResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Query for the full transactions in the given range of blocks.
         * Returns a stream of `TransactionInfoResponse`s.
         *
         * @generated from rpc penumbra.view.v1.ViewService.TransactionInfo
         */
        transactionInfo: {
            name: "TransactionInfo",
            I: TransactionInfoRequest,
            O: TransactionInfoResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Query for owned position IDs for the given trading pair and in the given position state.
         *
         * @generated from rpc penumbra.view.v1.ViewService.OwnedPositionIds
         */
        ownedPositionIds: {
            name: "OwnedPositionIds",
            I: OwnedPositionIdsRequest,
            O: OwnedPositionIdsResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Translates a high-level intent ("send X funds to Y address") into a complete transaction plan.
         *
         * @generated from rpc penumbra.view.v1.ViewService.TransactionPlanner
         */
        transactionPlanner: {
            name: "TransactionPlanner",
            I: TransactionPlannerRequest,
            O: TransactionPlannerResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Returns authentication data for the given transaction plan.
         *
         * This method takes a complete transaction plan, so that the client can get a
         * consistent set of authentication paths to a common root for the entire
         * transaction.  (Otherwise, if a client made multiple requests, the wallet
         * service could have advanced the state commitment tree  between queries).
         *
         * @generated from rpc penumbra.view.v1.ViewService.Witness
         */
        witness: {
            name: "Witness",
            I: WitnessRequest,
            O: WitnessResponse,
            kind: MethodKind.Unary,
        },
        /**
         * Like `Witness`, but immediately uses the witness data to build (prove) the transaction.
         *
         * This method is useful for clients that can't easily do proving themselves, either because
         * they're not written in Rust and can't easily import the proving code, or because they don't
         * have access to proving keys, or some other reason.
         *
         * This method streams status updates to the caller before finally returning the transaction.
         *
         * @generated from rpc penumbra.view.v1.ViewService.WitnessAndBuild
         */
        witnessAndBuild: {
            name: "WitnessAndBuild",
            I: WitnessAndBuildRequest,
            O: WitnessAndBuildResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Authorize a transaction plan and build the transaction.
         *
         * This method is only supported on view servers that have access to a custody
         * service.  Otherwise, it will fail.
         *
         * Penumbra's transaction authorization mechanism is designed so transactions
         * can be signed and built (proved) concurrently. This allows implementations
         * to, e.g., start proving optimistically while presenting the user with an
         * approval dialog.
         *
         * This method streams status updates to the caller before finally returning the transaction.
         *
         * @generated from rpc penumbra.view.v1.ViewService.AuthorizeAndBuild
         */
        authorizeAndBuild: {
            name: "AuthorizeAndBuild",
            I: AuthorizeAndBuildRequest,
            O: AuthorizeAndBuildResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Broadcast a transaction to the network, optionally waiting for full confirmation.
         *
         * This method streams status updates to the caller before finally returning confirmation.
         *
         * @generated from rpc penumbra.view.v1.ViewService.BroadcastTransaction
         */
        broadcastTransaction: {
            name: "BroadcastTransaction",
            I: BroadcastTransactionRequest,
            O: BroadcastTransactionResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Get delegation tokens for a given address index. Each delegation token will
         * be represented by a `ValueView` with the given address index's balance of
         * that token. Each `ValueView`'s `extended_metadata` field will contain the
         * `ValidatorInfo` of the delegated validator.
         *
         * @generated from rpc penumbra.view.v1.ViewService.DelegationsByAddressIndex
         */
        delegationsByAddressIndex: {
            name: "DelegationsByAddressIndex",
            I: DelegationsByAddressIndexRequest,
            O: DelegationsByAddressIndexResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Get unbonding tokens for the given address index, optionally filtered by
         * whether the tokens are currently claimable.
         *
         * @generated from rpc penumbra.view.v1.ViewService.UnbondingTokensByAddressIndex
         */
        unbondingTokensByAddressIndex: {
            name: "UnbondingTokensByAddressIndex",
            I: UnbondingTokensByAddressIndexRequest,
            O: UnbondingTokensByAddressIndexResponse,
            kind: MethodKind.ServerStreaming,
        },
        /**
         * Gets the auctions controlled by the user's wallet.
         *
         * @generated from rpc penumbra.view.v1.ViewService.Auctions
         */
        auctions: {
            name: "Auctions",
            I: AuctionsRequest,
            O: AuctionsResponse,
            kind: MethodKind.ServerStreaming,
        },
    }
};
